import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './design-system/gb-variables.css';
import './design-system/core.css';
import './i18n';

// Esperar a que el DOM esté listo
const container = document.getElementById('app');
// El index.html tiene un div id="app"? Vamos a verificarlo, si no, lo inyectamos al body o creamos el root.
// En el index.html original creo que no había un container raíz para React, así que lo haré robusto.

if (!container) {
    const rootDiv = document.createElement('div');
    rootDiv.id = 'root';
    document.body.appendChild(rootDiv);
    const root = createRoot(rootDiv);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else {
    const root = createRoot(container);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}
